import React, { forwardRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { SortableWidgetProps, Tabs, Widget } from '@creditsights/styleguide-web';
import { ROUTES } from '../../../Base.constants';
import { Region } from '../../../models';
import { useFetchMorningCommentaries } from '../../../hooks/articles';

import styles from './MorningCommentWidget.module.scss';

const cx = classNames.bind(styles);
const COMMENT_COUNT = 1;

const MorningCommentWidget = (props: SortableWidgetProps, ref): React.ReactElement => {
  const [region, setRegion] = useState(Region.UnitedStates);
  const { data: articles = [], isLoading, isError, refetch } = useFetchMorningCommentaries(region, COMMENT_COUNT);
  const tabData = [
    {
      active: region === Region.UnitedStates,
      onClick: () => setRegion(Region.UnitedStates),
      label: 'United States',
      dataTestId: 'united-states-region',
    },
    {
      active: region === Region.Europe,
      onClick: () => setRegion(Region.Europe),
      label: 'Europe',
      dataTestId: 'europe-region',
    },
  ];

  return (
    <Widget
      headerTitle="Morning Comment"
      isLoading={isLoading}
      isError={isError}
      onRetryAfterErrorClick={refetch}
      fixedHeight
      firstLine={
        <div className="to-translate">
          <Tabs tabs={tabData} />
        </div>
      }
      wrapFirstLine
      hideFirstLineWhenLoading={false}
      dataTestId="morning-comment"
      ref={ref}
      {...props}
    >
      <div className={classNames(cx('body'), 'to-translate')} data-testid="morning-comment-content">
        {articles.length ? (
          <>
            <div className={cx('summary')} data-testid="summary">
              <span dangerouslySetInnerHTML={{ __html: articles[0].content.summary }} />
            </div>
            <Link to={ROUTES.article(articles[0].id)} className={cx('link')} data-testid="read-more-link">
              Read More
            </Link>
          </>
        ) : (
          'Morning comment not found'
        )}
      </div>
    </Widget>
  );
};

export default forwardRef(MorningCommentWidget);
